import { render, staticRenderFns } from "./Produit_Panier_Index.vue?vue&type=template&id=6765ff98&scoped=true&"
import script from "./Produit_Panier_Index.vue?vue&type=script&lang=js&"
export * from "./Produit_Panier_Index.vue?vue&type=script&lang=js&"
import style0 from "./Produit_Panier_Index.vue?vue&type=style&index=0&id=6765ff98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6765ff98",
  null
  
)

export default component.exports